export const VIDEO_WATERMARK_PRESETS = [
  { id: 'haochen-pearl-v2', label: '灏尘说 · 米白（暗色画面）', imageUrl: new URL('../assets/video-watermarks/haochen-pearl-v2.png', import.meta.url).href },
  { id: 'haochen-ink-v2', label: '灏尘说 · 墨黑（亮色画面）', imageUrl: new URL('../assets/video-watermarks/haochen-ink-v2.png', import.meta.url).href },
] as const;
export function videoWatermarkPreset(id: string) {
  const preset = VIDEO_WATERMARK_PRESETS.find(item => item.id === id);
  if (!preset) throw new Error('频道水印样式无效');
  return preset;
}
